import { Extension } from "@tiptap/core";

const DropCap = Extension.create({

  name: "dropCap",

  addGlobalAttributes() {

    return [

      {

        types: [
          "paragraph"
        ],

        attributes: {

          dropCap: {

            default: false,

            parseHTML: (element) =>
              element.getAttribute(
                "data-drop-cap"
              ) === "true",

            renderHTML: (attributes) => {

              if (!attributes.dropCap) {
                return {};
              }

              return {
                "data-drop-cap": "true"
              };

            }

          }

        }

      }

    ];

  },


  addCommands() {

    return {

      toggleDropCap:
        () =>
        ({ commands, editor }) => {

          if (!editor.isActive("paragraph")) {
            return false;
          }

          const currentValue =
            editor.getAttributes(
              "paragraph"
            ).dropCap;

          return commands.updateAttributes(
            "paragraph",
            {
              dropCap: !currentValue
            }
          );

        }

    };

  }

});

export default DropCap;